module.exports = __webpack_public_path__ + "static/media/mobile-android.e8c2c770.svg";